import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FinanceService } from 'src/app/_services/finance.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BusinessFinanceClientComponent } from '../business-finance-client/business-finance-client.component';
import { WARNING_TYPE_OPTIONS } from 'src/app/shared/models/options/financeClientWarningType.options.model';
import { LANGUAGE_TYPE_OPTIONS } from 'src/app/shared/models/options/languageType.options.model';
import { CreateFinanceClientRequest } from './models/createFinanceClient.request.model';
import { UpdateFinanceClientRequest } from './models/updateFinanceClient.request.model';
import { ConfirmationService } from 'src/app/shared/confirmDialog/services/confirmation.service';
import { ErrorResponseService } from 'src/app/shared/errorResponse/errorResponse.service';
import { catchError, debounceTime, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
@Component({
  selector: "app-add-client-finance",
  templateUrl: "./add-client-finance.component.html",
  styleUrls: ["./add-client-finance.component.css"],
})
export class AddClientFinanceComponent implements OnInit {
  pibControl = new FormControl("");
  suggestedCompany: any = null;
  loading = false;
  isEdit: boolean = false;
  editId: number = null;
  error: string | null = null; // Error state
  options = {
    languages: LANGUAGE_TYPE_OPTIONS,
    warningTypes: WARNING_TYPE_OPTIONS,
  };

  addFinanceForm = new FormGroup({
    username: new FormControl<string>(
      "",
      Validators.compose([Validators.required])
    ),
    address: new FormControl<string>(
      "",
      Validators.compose([Validators.required])
    ),
    country: new FormControl<string>(
      "",
      Validators.compose([Validators.required])
    ),
    post: new FormControl<string>(
      "",
      Validators.compose([Validators.required])
    ),
    pib: new FormControl<string>("", Validators.compose([Validators.required])),
    indetificationNumber: new FormControl<string>(
      "",
      Validators.compose([Validators.required])
    ),
    //password je city
    password: new FormControl<string>(""),
    customer1: new FormControl<string>(""),
    customer2: new FormControl<string>(""),
    startState: new FormControl<number | null>(null),
    firstName: new FormControl<string>(""),
    email: new FormControl<string>("", [Validators.email]),
    name: new FormControl<string>(""),
    phone: new FormControl<string>(""),
    note: new FormControl<string>(""),
    mobilePhone: new FormControl<string>(""),
    fax: new FormControl<string>(""),
    sendEmail: new FormControl<boolean>(false),
    isSrbClient: new FormControl<boolean>(false),
    isGovernmentCompany: new FormControl<boolean>(false),
    governmentCompanyAdditionalInfo: new FormGroup({
      jbkjs: new FormControl<string>(""),
      contractId: new FormControl<string>(""),
      contractDate: new FormControl<Date | null>(null),
    }),
  });

  private _clientTinLength = 9;

  constructor(
    @Optional() public dialogRef: MatDialogRef<BusinessFinanceClientComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private financeService: FinanceService,
    private router: Router,
    private notify: NotificationService,
    private confirmationService: ConfirmationService,
    private errorResponseService: ErrorResponseService
  ) {}

  ngOnInit(): void {
    if (this.data != null) {
      // console.log(this.data);
      this.patchValues(this.data);
      this.isEdit = true;
      this.editId = this.data.clientFinance.id;
    }
    this.searchByPibNbsAPI();
  }
  searchByPibNbsAPI() {
    this.pibControl.valueChanges
      .pipe(
        debounceTime(300),
        switchMap((value: string) => {
          if (value && value.length >= 8) {
            this.loading = true;
            this.suggestedCompany = null;
            this.error = null;
            return this.financeService.searchCompanyByPibFormNbsApi(value).pipe(
              catchError((err) => {
                this.loading = false;
                this.error = "Došlo je do greške. Pokušajte ponovo.";
                return of(null);
              })
            );
          } else {
            this.loading = false;
            this.suggestedCompany = null;
            return of(null);
          }
        })
      )
      .subscribe((data: any) => {
        this.loading = false;
        if (data) {
          this.suggestedCompany = data;
        } else {
          this.suggestedCompany = null;
        }
      });
  }

  onOptionSelected(selectedCompany: any) {
    if (selectedCompany) {
      this.populateForm(selectedCompany);
    }
  }
  onPibInput() {}

  populateForm(company: any) {
    this.addFinanceForm.patchValue({
      username: company.companyName,
      address: company.address,
      pib: company.taxIdentificationNumber,
      indetificationNumber: company.nationalIdentificationNumber,
      password: company.city,
      country: "Republika Srbija",
    });
  }

  clearForm() {
    // Optionally clear the form if no company is found
    this.addFinanceForm.reset();
  }

  displayCompany(company: any): string {
    return company
      ? `${company.companyName} (${company.taxIdentificationNumber})`
      : "";
  }

  patchValues(data) {
    // console.log(data);
    var dataSource = data["clientFinance"];
    this.addFinanceForm.patchValue(dataSource);
  }

  onCloseClick(): void {
    this.dialogRef.close();
    this.router.navigate(["/finance/business/client"]);
  }

  onSubmit() {
    if (this.addFinanceForm.invalid) {
      this.notify.warning(`Forma nije isprovno popunjena`);
      this.addFinanceForm.markAllAsTouched();
      return;
    }

    this.confirmSaveIfTinIsEligible();
  }

  private confirmSaveIfTinIsEligible(): void {
    this.addFinanceForm.controls.pib.value?.length === this._clientTinLength
      ? this.save()
      : this.openConfirmSaveDialog();
  }

  private openConfirmSaveDialog(): void {
    this.confirmationService.confirm({
      message: `Da li želite da nastavite sa procesom ${
        this.isEdit ? "ažuriranja" : "unosa"
      } klijenta? Ukupan broj karaktera polja PIB = ${
        this.addFinanceForm.controls.pib.value?.length
      }`,
      accept: () => this.save(),
    });
  }

  private save(): void {
    this.isEdit ? this.edit() : this.insert();
  }

  private edit(): void {
    this.financeService.editUser(this._updateRequest(), this.editId).subscribe(
      (response) => this.notify.success(`Podaci su uspešno ažurirani`),
      (error) => {
        this.displayError(error);
      },
      ()=> {this.onCloseClick();}
    );
  }

  private _updateRequest(): UpdateFinanceClientRequest {
    return new UpdateFinanceClientRequest(this.addFinanceForm.value, {
      id: this.editId,
    });
  }

  private insert() {
    this.financeService
      .addUser(new CreateFinanceClientRequest(this.addFinanceForm.value))
      .subscribe(
        (response) => {
          // console.log('Uspešno poslato na server', response);
          this.notify.success(`Stranka je uspešno sačuvana`);
        },
        (error) => {
          this.displayError(error);
        },
        () => {this.router.navigate(["/finance/business/client"])}
      );
  }

  onSubmitNew() {
    if (this.addFinanceForm.invalid) {
      this.notify.warning(`Forma nije isprovno popunjena`);
      this.addFinanceForm.markAllAsTouched();
      return;
    }

    this.addFinanceForm.controls.pib.value.length === this._clientTinLength
      ? this.saveForNewSubmit()
      : this.openConfirmForSaveNewDialog();
  }

  private openConfirmForSaveNewDialog(): void {
    this.confirmationService.confirm({
      message: `Da li želite da nastavite sa procesom ${
        this.isEdit ? "ažuriranja" : "unosa"
      } klijenta? Ukupan broj karaktera polja PIB = ${
        this.addFinanceForm.controls.pib.value?.length
      }`,
      accept: () => this.saveForNewSubmit(),
    });
  }

  private saveForNewSubmit(): void {
    if (this.isEdit) {
      const updateRequest = new UpdateFinanceClientRequest(
        this.addFinanceForm.value,
        {
          id: this.editId,
        }
      );
      this.financeService.editUser(updateRequest, this.editId).subscribe(
        (response) => {
          console.log("Uspešno poslato na server", response);
          this.notify.warning(`Podaci su uspešno ažurirani`);
        },
        (error) => {
          this.displayError(error);
        }
      );
      return;
    }
    this.financeService
      .addUser(new CreateFinanceClientRequest(this.addFinanceForm.value))
      .subscribe(
        (response) => {
          console.log("Uspešno poslato na server", response);
          this.notify.warning(`Stranka je uspešno sačuvana`);
        },
        (error) => {
          this.displayError(error);
        }
      );
    this.addFinanceForm.reset({});
  }

  onCustomer1Change(checkBox1: boolean) {
    if (checkBox1) {
      this.addFinanceForm.get("customer1").setValue("Kupac");
    } else {
      this.addFinanceForm.get("customer1").setValue("");
    }
  }
  onCustomer2Change(checkBox2: boolean) {
    if (checkBox2) {
      this.addFinanceForm.get("customer2").setValue("Dobavljač");
    } else {
      this.addFinanceForm.get("customer2").setValue("");
    }
  }

  onSendEmialChange(checkBox1: boolean) {
    if (checkBox1) {
      this.addFinanceForm.get("sendEmail").setValue(checkBox1);
    } else {
      this.addFinanceForm.get("sendEmail").setValue(checkBox1);
    }
  }

  private displayError(error): void {
    this.errorResponseService.openDialog(error);
  }
  onIsGovernmentCompanyChange(isChecked: boolean): void {
    const additionalInfoGroup = this.addFinanceForm.get('governmentCompanyAdditionalInfo') as FormGroup;
  
    if (isChecked) {
      additionalInfoGroup.get('jbkjs')?.setValidators(Validators.required);
      additionalInfoGroup.get('contractId')?.setValidators(Validators.required);
      additionalInfoGroup.get('contractDate')?.setValidators(Validators.required);
    } else {
      additionalInfoGroup.get('jbkjs')?.clearValidators();
      additionalInfoGroup.get('contractId')?.clearValidators();
      additionalInfoGroup.get('contractDate')?.clearValidators();
    }
  
    additionalInfoGroup.get('jbkjs')?.updateValueAndValidity();
    additionalInfoGroup.get('contractId')?.updateValueAndValidity();
    additionalInfoGroup.get('contractDate')?.updateValueAndValidity();
  }
}

  
 
  
   

